import { BillingPage } from '@/features/billing/BillingPage';
import { useT } from '@/i18n/LocaleProvider';
import { useDocumentTitle } from '@/lib/useDocumentTitle';

export function BillingRoute() {
  const t = useT();
  useDocumentTitle(t('billing.title'));
  return <BillingPage />;
}
